var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 774,
    height: 110,
    viewBox: "0 0 774 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13402",
    "data-name": "Group 13402",
    transform: "translate(-573 -132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11252",
    "data-name": "Rectangle 11252",
    d: "M10,0H762a12,12,0,0,1,12,12v98a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V10A10,10,0,0,1,10,0Z",
    transform: "translate(573 132)",
    fill: "#170a33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zenus_Bank_RGB_Turqoise",
    transform: "translate(646.5 172.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M230.866,37.9V59.708a2.623,2.623,0,0,1-2.629,2.621h-9.622a3.038,3.038,0,0,1-3.035-3.035V37.89H208.39V60.725a6.814,6.814,0,0,0,6.814,6.814h16.037a6.814,6.814,0,0,0,6.814-6.814V37.89h-7.189Z",
    transform: "translate(-74.991 -37.874)",
    fill: "#00baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M287.712,47.2V46.069a3.035,3.035,0,0,0-3.027-3.028h-9.223c-1.643,0-3.4.4-2.918,3.168.751,2.237,3.012,2.5,8.285,3.818,2.292.563,7.174,1.447,9.45,2.707a7.721,7.721,0,0,1,4.185,4.819,11.264,11.264,0,0,1,.391,3.074c0,.172-.016.336-.023.493a6.76,6.76,0,0,1-6.759,6.4H272.465a7.141,7.141,0,0,1-7.135-7.135v-2.2h7.15v1.127a3.035,3.035,0,0,0,3.028,3.028h9.223c1.643,0,3.732-.6,2.918-3.168-.751-2.237-2.957-2.05-8.23-3.356-4.428-1.111-7.228-1.9-9.5-3.161H269.9a7.756,7.756,0,0,1-4.178-4.819,11.265,11.265,0,0,1-.391-3.074c0-.172.016-.336.023-.493a6.76,6.76,0,0,1,6.759-6.4H287.72A7.131,7.131,0,0,1,294.854,45v2.2H287.7Z",
    transform: "translate(-87.387 -37.87)",
    fill: "#00baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M94.68,67.546V37.92h29.579v5.195H101.893v6.869h17.179v5.195H101.893v7.189h22.39v5.187H94.68Z",
    transform: "translate(-50.237 -37.881)",
    fill: "#00baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M151.47,67.585V37.92h6.751L173.93,56.03V37.92h7.182V67.585H174.36L158.652,49.436V67.585Z",
    transform: "translate(-62.6 -37.881)",
    fill: "#00baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M37.87,69.958v4.389H67.5V69.16H38.652Z",
    transform: "translate(-37.87 -44.682)",
    fill: "#00baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M37.88,37.92v5.187H56.507L44.631,55.24h11L67.506,43.255V37.92Z",
    transform: "translate(-37.872 -37.881)",
    fill: "#00baff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15707",
    "data-name": "Path 15707",
    d: "M37.88,37.92V70.86h118.3l-75.42,77.06h69.855L226.033,71.8V37.92Z",
    transform: "translate(1384.422 279.92) rotate(-180)",
    fill: "#00baff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormHeader);
export default __webpack_public_path__ + "static/media/form_header.23e4e62645dd89ddd0fa1aab7054a372.svg";
export { ForwardRef as ReactComponent };